module.exports = __webpack_public_path__ + "img/secure-2.3a2b77e1.png";